<template>
  <div>
    <doc-title text="Suche"></doc-title>
  
    <h1>
      Suche
    </h1>
    <hr>

    <list resource="posts/search" :params="{ q: $route.query.q }"></list>
  </div>
</template>

<script>
  import DocTitle from '@/vues/helpers/doc-title.vue';
  import List from './list.vue';

  export default {
    name: 'PostsSearch',
    components: { DocTitle, List },
    mounted () {
      this.track();
    },
    watch: {
      '$route.query.q' () {
        this.track();
      }
    },
    methods: {
      track () {
        try {
          this.$ua.trackEvent('post', 'search');
        } catch (e) { /* Adblocker */ }

        try {
          this.$mixpanel.track('Post Search', {
            q: this.$route.query.q
          });
        } catch (e) { /* Adblocker */ }
      }
    }
  };
</script>
